import {API_BASE_URL,clearOrdinarySession,getOrdinaryToken} from './ordinarySession';
export async function apiFetch(input:RequestInfo|URL,init?:RequestInit):Promise<Response>{
 const raw=typeof input==='string'?input:input instanceof URL?input.href:input.url;
 const internal=raw.startsWith('/api/')||raw.startsWith('/health');
 const target=internal&&API_BASE_URL?API_BASE_URL.replace(/\/$/,'')+raw:input;
 const response=await fetch(target,internal?{...init,cache:'no-store'}:init);
 if(response.status===401){
  const headers=init?.headers;let authorization:string|undefined|null;
  if(headers&&typeof (headers as Headers).get==='function')authorization=(headers as Headers).get('Authorization');
  else if(Array.isArray(headers))authorization=headers.find(([key])=>key.toLowerCase()==='authorization')?.[1];
  else if(headers)authorization=Object.entries(headers).find(([key])=>key.toLowerCase()==='authorization')?.[1];
  const current=getOrdinaryToken();if(current&&authorization===`Bearer ${current}`)clearOrdinarySession();
 }
 return response;
}
